import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  breadcrumbList: string[];

  get(): string[]{
    return this.breadcrumbList;
  }

  set(newList: string[]){
    this.breadcrumbList = newList; 
  }
}
